module.exports = __webpack_public_path__ + "static/media/LightEnoughtoFloat.9bef2743.jpg";